<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'
import type { Team } from '~/types'

defineOptions({
  name: 'TeamStatsNav',
})

interface Props {
  team: Team.Model
}

interface TeamStatNavItem {
  label: string
  to: RouteLocationRaw
}

const props = defineProps<Props>()
const { slug } = useTeam(props.team)

const seasonId = useRouteQuery<number | undefined>('season', undefined, { transform: val => val ? Number(val) : undefined })

const items = computed<TeamStatNavItem[]>(() => {
  return [
    {
      label: 'Team Stats',
      name: 'teams-slug-stats',
    },
    {
      label: 'Results',
      name: 'teams-slug-stats-results',
    },
    {
      label: 'Individual',
      name: 'teams-slug-stats-individual',
    },
  ].map(({ label, name }) => {
    return {
      label,
      to: {
        name,
        params: {
          slug: slug.value,
        },
        query: {
          season: seasonId.value,
        },
      },
    }
  })
})
</script>

<template>
  <ul class="team-stats-nav">
    <TeamStatsNavItem
      v-for="({ to, label }, index) in items"
      :key="`team-stats-nav-item-${index}`"
      :to
      class="team-stats-nav__item"
    >
      {{ label }}
    </TeamStatsNavItem>
  </ul>
</template>

<style scoped lang="scss">
.team-stats-nav {
  @apply flex justify-center my-5;

  &__item {
    @apply inline-block;
  }
}
</style>
